module.exports = __webpack_public_path__ + "img/nba-oe-playbook.1dc897b3.jpg";